import utils from 'utils'
class abnormalTaskTrackingCtrl {
    constructor($scope, httpRequest, $state, $stateParams, sweetalert, logger, ATTFieldConfig, $timeout, authService, $filter, Upload, $uibModal) {
        $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
        $scope.select = {}
        $scope.treeConfig = {
            isCheckall: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.importBtnCollapsed = false
        // 列表查询字段设置
        $scope.customizedConfig = ATTFieldConfig
        // 查询的参数
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                applyPeriod: utils.getLastMonthFirstLast().preMonth,
                taxNo: '',
                companyName: '',
                departmentNo: '',
                regionName: '',
                cityName: '',
                province: '',
                taxType: '',
                taskType: '',
            },
        }
        // 重置
        $scope.reset = function () {
            $scope.belleRegionCityList = []
            $scope.queryParam.param = {
                applyPeriod: utils.getLastMonthFirstLast().preMonth,
                taxNo: '',
                companyName: '',
                departmentNo: '',
                regionName: '',
                cityName: '',
                province: '',
                taxType: '',
                taskType: '',
            }
            // queryInfo()
            getUserInfo()
        }
        // 勾选的信息
        $scope.selectedRows = []
        //自动查询展示
        const queryInfo = function queryInfo() {
            const openLoading =
                $scope.queryParam.pageSize >= 100
                    ? window.layer.msg('正在查询，请耐心等待', {
                          time: 0,
                          skin: 'layer-loading-self',
                          icon: 16,
                          shade: 0.5,
                      })
                    : null
            httpRequest
                .post_queryRpaAbnormalTaskList(queryDataHandle($scope.queryParam))
                .then((res) => {
                    $scope.listData = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.queryParam.pageNum = res.data.value.pageNum
                    $scope.queryParam.pageSize = res.data.value.pageSize
                    $scope.selectedRows = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                })
        }
        function queryDataHandle(queryData) {
            $scope.employeeList = []
            const { selectedFollower } = $scope.select
            selectedFollower.forEach(item => {
                $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
            });
            queryData.param.employeeList = $scope.employeeList
    
            return queryData
        }
        // 搜索
        $scope.searchList = function () {
            queryInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            queryInfo()
        }
        // 改变税款所属月份
        $scope.updateSearch = function () {
            queryInfo()
        }
        // 字典
        const typecodeArrStr = [
            'department_no',
            'sb_tax_type', //申报税种
            'sb_abnormal_type', // 申报-异常类型
            'glsale_declaration', // 申报状态
            'glsale_pay', // 缴款状态
            'glsale_fillInStatus', // 申报填入状态
            'enterprise_fillInStatus', // 财务报表报送状态
            'task_personStatus', // 人员信息报送状态
            'task_salaryStatus', // 所得项目明细表提交状态
            'voucher_download_status', // 完税证明下载状态
            'glsale_acquisition', // 发票采集状态
        ]
        $scope.dictionary = {}
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictionary, res.data.value)
        })
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 联动查询管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                if (v.enumName === enumName) {
                    return v.enumCode
                }
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                if (v.regionName === enumName) {
                    return v.regionNo
                }
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 获取所有主管税局信息
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        // queryInfo()
        $scope.toTrigger = () => {
            const list = $scope.selectedRows
            if (!list.length) return logger.logError('请选择要重新触发数据！')
            const idList = list.map((el) => {
                return el.id
            })
            httpRequest.post_retrigger({ idList }, '重新触发成功').then((res) => {
                queryInfo()
            })
        }
        // 导出
        $scope.exportExcel = function exportExcel() {
            const exportParam = $.extend({}, $scope.queryParam.param)
            let employees = exportParam.employeeList
            delete exportParam.employeeList
            exportParam.employees = employees
            const url = `${host.etcloudIvatApp}exportRpaAbnormalTaskList?accessToken=${localStorage.getItem('id_token')}`
            utils.post_downLoadEncode(exportParam, url)
        }
        function getUserInfo() {
            $scope.params = {
                pageSize: 2000,
                pageNum: 1,
                param: {
                    isRoleOwner: '1', // 拥有本机构角色
                    orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
                },
            }
            httpRequest.get_getIvatEmployeeList().then((res) => {
                $scope.followerList = dataHandle(res.data.value)
                $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
                queryInfo()
            })
        }
        getUserInfo()
        function dataHandle(list) {
            list.forEach((el,index) => {
                el.orgId = index
                el.orgName = el.employeeName + '|' + el.employeeNumber
                if ($scope.currentUserInfo.realName == el.employeeName) {
                    el.checked = true
                } else {
                    el.checked = false
                }
            })
            return list
        }
    }
}
abnormalTaskTrackingCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'sweetalert', 'logger', 'ATTFieldConfig', '$timeout', 'authService', '$filter', 'Upload', '$uibModal']
export default abnormalTaskTrackingCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/abnormalTaskTracking/abnormalTaskTrackingCtrl.js